import { Helmet } from 'react-helmet-async'
import { Routes, Route, Outlet } from 'react-router'

import { AdminProvider } from './context/AdminContext'

import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Portfolio from './components/Portfolio'
import Skills from './components/Skills'
import Certificates from './components/Certificates'
import Education from './components/Education'
import Contact from './components/Contact'
import Footer from './components/Footer'
import ScrollProgress from './components/ScrollProgress'
import BackgroundParticles from './components/BackgroundParticles'
import ErrorBoundary from './components/ErrorBoundary'

import AdminPage from './pages/admin/index'

function Layout() {
  return (
    <div className="min-h-screen transition-colors duration-500 flex flex-col relative z-0">
      <BackgroundParticles />
      <ScrollProgress />
      <Navbar />
      <main className="flex-grow z-10 relative">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <AdminProvider>
        <Helmet>
          <title>Shiv Shankar Pandit — Software Engineer</title>
          <meta
            name="description"
            content="Portfolio of Shiv Shankar Pandit, Software Engineer specializing in modern web development."
          />
          <meta property="og:title" content="Shiv Shankar Pandit — Software Engineer" />
          <meta property="og:description" content="Portfolio of Shiv Shankar Pandit, Software Engineer specializing in modern web development." />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        
        <Routes>
          <Route path="/admin/*" element={<AdminPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Hero />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/education" element={<Education />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </AdminProvider>
    </ErrorBoundary>
  )
}
